import React from 'react';

export interface ITypographyProps {
  variant?: 'xl' | 'l' | 'm' | 's' | 'xs' | 'social' | 'th' | 'bevel';

  mb?: 'medium' | 'large';

  children?: React.ReactNode;

  className?: string;

  /**
   * The tag / component to use for the wrapper
   */
  component?: React.ElementType;
}

const Typography = ({
  variant = 'm',
  children,
  component = 'p',
  className = '',
  mb,
  ...rest
}: ITypographyProps & React.HTMLAttributes<HTMLElement>) => {
  return React.createElement(
    component,
    {
      className: `typography typography--${variant} ${className}`,
      style: { marginBottom: mb ? `var(--margin-${mb})` : undefined },
      ...rest,
    },
    children,
  );
};

export default Typography;
